import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ReportsService } from '../../../../services/reports.service';
import { saveAs } from 'file-saver';
import { RouterModule } from '@angular/router';
import { CommonService } from '../../../../services/common.service';

@Component({
    selector: 'app-inspector-validation-required',
    imports: [TableModule, CommonModule, FormsModule, RouterModule,],
    templateUrl: './inspector-validation-required.component.html',
    styleUrl: './inspector-validation-required.component.scss'
})
export class InspectorValidationRequiredComponent {
 constructor(private report: ReportsService,
      public commonService: CommonService
 ) { }
  getInspectorValidationData: any;
  blueTagNumber: string = '';
  showTable: boolean = false;
  isLoading: boolean = false;
  facilityID: string = ''
  userCAI:string = '';

  ngOnInit() {
    this.facilityID = localStorage.getItem('current_facility_id') || 'ES';
    this.userCAI = this.commonService.getUserCai();
    this.getRecommendedNinetyDaysReport();
  }


  getRecommendedNinetyDaysReport() {
    this.isLoading = true;
    this.report.getTLRRemovalVerification(this.facilityID, this.userCAI)
      .subscribe({
        next: (data) => {
          this.getInspectorValidationData = data;
          this.isLoading = false;

        },
        error: (error) => {
          console.error('Error fetching report:', error);
          this.isLoading = false;

        }
      });
  }

  exportToExcel() {
    const facilityId = localStorage.getItem('current_facility_id');

    if (!facilityId) {
      console.error('Facility ID is missing.');
      return;
    }

    let params = {
      facilityId: facilityId,
      userCAI: this.commonService.getUserCai(),
    }
    this.report.getTLRRemovalVerificationExcel(params)
      .subscribe({
        next: (fileData: any) => {
          if (fileData) {
            saveAs(fileData, 'inspector-validation-required.xlsx');
          }

        },
        error: (err: any) => {
          console.error('Error fetching report details:', err);
        }
      })
  }
}
